import Service from "../Service";

const resource = "packingloss/";

export default {
    save(cmp, requestID){
        return Service.post(resource + "save", cmp,{
            params: {requestID: requestID},
        });
    },
    pagination(dtr, requestID){
        return Service.post(resource + "pagination", dtr,{
            params:{requestID: requestID},
        });
    },
    list(fas, requestID) {
        return Service.post(resource + "list", fas, {
          params: { requestID: requestID },
        });
    },
   
}